var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { IconTextValuePill } from '../elements/icon-text-value-pill';
import { CellLabel } from '../elements/cell-label';
import { SegmentBar } from '../elements/segment-bar';
import { useInViewEffect } from '../hooks/use-in-view-effect';
import { useLang } from '../hooks/use-lang';
import { useComponentProps } from '../context/component-props-context';
import { ContentNode } from '../entities/content-node';
import { EntityMetaSection } from '../entities/entity-meta-section';
var cls = classNames('indicator-layout-panel');
var IndicatorLayoutPanelDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: ", ";\n    width: 100%;\n    padding-bottom: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: ", ";\n    width: 100%;\n    padding-bottom: ", ";\n  "])), theme.UNIT(5), theme.UNIT(2))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 1.7em;\n    font-weight: 500;\n  "], ["\n    font-size: 1.7em;\n    font-weight: 500;\n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-bottom: ", ";\n    color: ", ";\n  "], ["\n    padding-bottom: ", ";\n    color: ", ";\n  "])), theme.UNIT(3), theme.COLOR('mid'))
});
var StatusBarStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n   width: 100%;\n  "], ["\n   width: 100%;\n  "])))
});
var ChartStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    max-width: 400px;\n  "], ["\n    max-width: 400px;\n  "])))
});
var DescriptionStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 300;\n  "], ["\n    color: ", ";\n    font-weight: 300;\n  "])), theme.COLOR('mid'))
});
var SourcesStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: 100%;\n  "], ["\n    width: 100%;\n  "])))
});
var ValueStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'IndicatorLayoutPanel',
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled(CellLabel)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  StatusBar: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), StatusBarStyles),
  Chart: styled(SegmentBar)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ChartStyles),
  Description: styled(ContentNode)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Sources: styled.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), SourcesStyles),
  Value: styled(IconTextValuePill)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles)
};
export var IndicatorLayoutPanel = function (props) {
  var componentProps = useComponentProps(My.NAME, IndicatorLayoutPanelDefaultProps, props);
  var className = props.className,
    entity = props.entity,
    colors = props.colors;
  var result = entity.result;
  var numericValue = result.numericValue,
    description = result.description,
    _a = result.links,
    links = _a === void 0 ? [] : _a;
  var _b = __read(React.useState(0), 2),
    value = _b[0],
    setValue = _b[1];
  var ref = useInViewEffect(function () {
    setValue(numericValue);
  });
  var t = useLang();
  var hasValue = numericValue !== null;
  var hasSources = !!links.length;
  var hasDescription = !!(description === null || description === void 0 ? void 0 : description.text);
  return React.createElement(My.Container, {
    ref: ref,
    className: cls.name(className)
  }, hasValue && React.createElement(My.StatusBar, null, React.createElement(My.Label, null, t('Status:')), React.createElement(My.Chart, {
    maxValue: 5,
    height: 8,
    value: value,
    tickWidth: 3,
    colors: colors
  })), hasDescription && React.createElement(My.Description, {
    entity: description
  }), hasSources && React.createElement(My.Sources, null, React.createElement(My.Label, null, t('Sources:')), React.createElement(EntityMetaSection, {
    items: links,
    direction: 'row'
  })));
};
IndicatorLayoutPanel.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;